import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TabControlComponent } from '../../../shared/controls/tab-control/tab-control.component';
import { TabPageComponent } from '../../../shared/controls/tab-control/tab-page.component';
import { ReportParameter } from '../../../shared/models/report-parameter.model';
import { ReportConstants } from '../../../shared/constants/report.constants';
import { AutoCompleteDropdownComponent } from '../../../shared/controls/auto-complete-dropdown/auto-complete-dropdown.component';

import { ErrorService } from '../../../shared/services/error-service';
import { ToastService } from '../../../shared/toast/toast.service';

import { InsurerService, PeriodService, AllPeriodItem } from '../../../../service/proxy';

@Component({
    selector: 'annexure-export-parameters',
    templateUrl: './annexure-export-parameters.component.html',
    styleUrls: ['./annexure-export-parameters.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        AutoCompleteDropdownComponent,
        TabControlComponent,
        TabPageComponent,
    ],

    providers: [
        InsurerService,
        PeriodService,
    ]
})
export class AnnexureExportParametersComponent implements OnInit {
    public periods: AllPeriodItem[] = [];
    public insurers: { id: number; name: string; }[] = [];

    public selectedStartPeriodId: number | undefined = undefined;
    public selectedEndPeriodId: number | undefined = undefined;
    public selectedInsurerId: number | undefined = undefined;

    public formSubmitted: boolean = false;

    constructor(
        private router: Router,
        private errorService: ErrorService,
        private toastService: ToastService,
        private insurerService: InsurerService,
        private periodService: PeriodService,
    ) {}

    ngOnInit(): void {
        this.getPeriodsForLookup();
        this.getInsurersForLookup();
    }

    getPeriodsForLookup(): void {
        this.periodService.getAllPeriods()
            .subscribe((data) => {
                this.periods = data.results || [];
            });
    }

    getInsurersForLookup(): void {
        this.insurerService.getAllInsurers()
            .subscribe({
                next: (response) => {
                    this.insurers = response.results.map(insurer => ({
                        id: insurer.id,
                        name: insurer.insurerName
                    }));
                },
                error: (error: any) => {
                    this.toastService.show('Failed to load insurers', 'error');
                    this.errorService.handleError(error);
                }
            }
        );
    }

    displayPeriod(option: any): string {
        const paddedMonth = ('0' + option.month).slice(-2);
        return `${option.year}-${paddedMonth}`;
    }

    onStartPeriodChange(selectedId: number | null): void {
        this.selectedStartPeriodId = selectedId ?? undefined;
    }

    onEndPeriodChange(selectedId: number | null): void {
        this.selectedEndPeriodId = selectedId ?? undefined;
    }

    onInsurerSelectionChange(selectedId: number | null): void {
        this.selectedInsurerId = selectedId ?? undefined;
    }

    onRunReport(form: any): void {
        this.formSubmitted = true;

        if (!form.valid || !this.selectedStartPeriodId || !this.selectedEndPeriodId || !this.selectedInsurerId) {
            return;
        }

        const startPeriod = this.periods.find(period => period.id === this.selectedStartPeriodId);
        const endPeriod = this.periods.find(period => period.id === this.selectedEndPeriodId);
        const insurer = this.insurers.find(insurer => insurer.id === this.selectedInsurerId);

        const padMonth = (month: number) =>
            month.toString().padStart(2, '0');

        const reportParams = [
            new ReportParameter(0, 'Start Period', this.selectedStartPeriodId, startPeriod
                ? `${startPeriod.year}/${padMonth(startPeriod.month)}`
                : ''),

            new ReportParameter(1, 'End Period', this.selectedEndPeriodId, endPeriod
                ? `${endPeriod.year}/${padMonth(endPeriod.month)}`
                : ''),

            new ReportParameter(2, 'Insurer', this.selectedInsurerId, insurer
                ? `${insurer.name}`
                : ''),
        ];

        this.router.navigate(['/report-viewer', ReportConstants.AnnexureExportReport], {
            state: { reportParams }
        });
    }
}